import { render } from "./PortfolioCategories.vue?vue&type=template&id=ed06e3b2&scoped=true"
import script from "./PortfolioCategories.vue?vue&type=script&lang=js"
export * from "./PortfolioCategories.vue?vue&type=script&lang=js"

import "./PortfolioCategories.vue?vue&type=style&index=0&id=ed06e3b2&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed06e3b2"]])

export default __exports__